<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { IconButton } from '@Shelly/shelly-design-system';
	import TokenTypeMenu from './TokenTypeMenu.svelte';

	export let disabled = false;
	export let active = false;

	const dispatch = createEventDispatcher<{
		select: 'room' | 'device' | 'group' | 'scene';
		close: void;
		refocus: void;
	}>();

	let plusMenuOpen = false;

	function handleClick() {
		if (active) {
			dispatch('close');
		} else {
			plusMenuOpen = !plusMenuOpen;
		}
		dispatch('refocus');
	}

	function handleSelect(e: CustomEvent<string>) {
		const type = e.detail as 'room' | 'device' | 'group' | 'scene';
		plusMenuOpen = false;
		dispatch('select', type);
		dispatch('refocus');
	}

	function handleMenuClose() {
		plusMenuOpen = false;
		dispatch('refocus');
	}
</script>

<div class="plus-menu-button" on:mousedown|preventDefault role="presentation">
	<IconButton
		variant="secondary"
		icon="fas fa-plus"
		aria-label={$format('filter_by_type', { default: 'Filter by type' })}
		title="Filter by type"
		class="add-button {active ? 'active' : ''}"
		{disabled}
		on:click={handleClick}
	/>
	{#if plusMenuOpen}
		<TokenTypeMenu on:select={handleSelect} on:close={handleMenuClose} />
	{/if}
</div>

<style>
	.plus-menu-button {
		position: relative;
	}

	.plus-menu-button :global(.add-button) {
		width: 32px;
		height: 32px;
		background: transparent !important;
		border-radius: 8px !important;
		border: none !important;
	}

	.plus-menu-button :global(.add-button:hover) {
		background: var(--color-background-2, #242527) !important;
		border: none !important;
		box-shadow: none !important;
		outline: none !important;
	}

	.plus-menu-button :global(.add-button.active) {
		background: var(--color-background-2, #242527) !important;
	}
</style>
